import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../context/ProductBuilder/machine';
import { Cart } from '../Cart';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  max-height: 70px;
  padding: 15px;
`;

const Title = styled.a`
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
`;

export const Header = () => {
  const [state] = useService(productBuilderMachine);
  const {
    store: { rootUrl },
  } = state.context;
  return (
    <Wrapper>
      <span>...</span>
      <Title href={rootUrl}>Veneta</Title>
      <Cart />
    </Wrapper>
  );
};
